exports.getWidth = function() {
    return Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
    );
}


//////////////////
// WEBPACK FOOTER
// ./static/js/dashboard.js
// module id = i4kO
// module chunks = 0